var map = {
	".": "qM4I",
	"./": "qM4I",
	"./01_server_url": "FVkd",
	"./01_server_url.json": "FVkd",
	"./03_error_code": "uv3h",
	"./03_error_code.json": "uv3h",
	"./04_rate_limits": "XvOK",
	"./04_rate_limits.json": "XvOK",
	"./04_server_url": "w7yn",
	"./04_server_url.json": "w7yn",
	"./index": "qM4I",
	"./index.js": "qM4I"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "M4z4";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/spot/api/basic ^.*$
// module id = M4z4
// module chunks = 3